import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import VolumeOffRoundedIcon from '@material-ui/icons/VolumeOffRounded';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: theme.palette.background.paper,
    padding: theme.spacing(0.5),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  icon: {
    marginRight: theme.spacing(3),
    fontSize: 60,
    color: theme.palette.text.primary,
  },
  text: {
    color: theme.palette.text.secondary,
    textTransform: 'capitalize',
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

interface IProps {
  children?: React.ReactChild;
  classe?: string;
}

export default function NoSoundCard(props: IProps) {
  const { children, classe } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card
      id="no-sound-card"
      className={classe ? clsx(classe, classes.container) : classes.container}
    >
      <CardContent className={classes.content}>
        <VolumeOffRoundedIcon className={classes.icon} />
        <div className={classes.description}>
          <Typography className={classes.text} variant="h6">
            {t('message.sound.card.noSound')}
          </Typography>
          <Typography className={classes.text}>
            {t('message.sound.card.noSoundText')}
          </Typography>
        </div>
      </CardContent>
      {children && <div className={classes.action}>{children}</div>}
    </Card>
  );
}
